import React from "react";
import { useTranslation } from "react-i18next";
import { useStaticQuery, graphql } from "gatsby";

const UpcomingProjects = () => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      thumbnailZipPay: file(
        relativePath: { eq: "images/zippay-thumbnail.png" }
      ) {
        publicURL
      }
    }
  `);

  return (
    <>
      <div id="upcoming-projects" className="bg-light-grey">
        <div className="container">
          <h2
            className="text-center"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
          >
            {t("zmt.upcomingProject.title")}
          </h2>
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div
                className="row d-flex justify-content-center"
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-easing="ease-in-quad"
              >
                <div className="col-lg-6 mb-4 d-flex align-items-stretch">
                  <div className="card">
                    <div className="coming-soon-badge badge-rounded">
                      {t("zmt.upcomingProject.comingSoon")}
                    </div>
                    <img
                      src={data.thumbnailZipPay.publicURL}
                      alt="ZipPay"
                      className="card-img-top"
                      loading="lazy"
                    />
                    <div className="card-body">
                      <h4>{t("zmt.upcomingProject.zipPay.title")}</h4>
                      <div className="card-text">
                        <p>{t("zmt.upcomingProject.zipPay.description")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingProjects;
